import { createSlice } from "@reduxjs/toolkit";
import { live_chat_count } from "./constant";

const chatSlice = createSlice({
  name: "chat",
  initialState: { message: [] },
  reducers: {
    addMessage: (state, action) => {
      if (state.message.length > live_chat_count) state.message.pop();
      state.message.unshift(action.payload);
    },
  },
});

export const { addMessage } = chatSlice.actions;
export default chatSlice.reducer;
